/* eslint-disable */

import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import CommentAnnotation from "./CommentAnnotation";
import AnnotationOverlay from "./AnnotationOverlay";
import StoreProductAnnotations from "./PubAnnotations";

class StoreProductAnnotationOverlay extends React.Component {
  constructor(props) {
    super(props);
    const { annotation } = this.props;

    this.state = { step: "new", type: annotation.simple_type };
    if (annotation.id != null) {
      this.state.step = "show";
    }
    this.handleTypeSelect = this.handleTypeSelect.bind(this);
  }

  componentDidMount() {
    const { klass } = this.props;

    if (klass.showAnnotationOnLoadId) {
      $("body").scrollTop($(ReactDOM.findDOMNode(this).children[0]).offset().top);
      klass.showAnnotationOnLoadId = null;
    }
  }

  componentDidUpdate() {
    const { annotation } = this.props;
    const { state } = this.state;

    if (annotation.id !== null && state.step !== "show") {
      this.setState({ step: "show", type: annotation.simple_type });
    }
  }

  commentAnnotation() {
    const {
      klass, number, annotation, roleType, annotationTypes, readOnly,
    } = this.props;

    return (
      <CommentAnnotation
        klass={klass}
        onSelect={this.handleTypeSelect}
        id={number}
        annotation={annotation}
        roleType={roleType}
        annotationTypes={annotationTypes}
        readOnly={readOnly}
      />
    );
  }

  handleTypeSelect(e) {
    e.preventDefault();

    const { annotation, annotationTypes } = this.props;
    const type = $(e.target).data("label");
    const at = annotationTypes.find(t => t.label === type);
    const step = "intro";
    annotation.type = at.class;
    annotation.type_label = at.label;
    if (at.type_label == "add_files") {
      StoreProductAnnotations.init().saveAddPhotoAnnotation(this.props.annotation, true)
    } else {
      this.setState({ type: at.type_label, step });
    }
  }

  addFirstMessage(id){
    const { annotation } = this.props;

    return {
      id: id,
      role_type: "area_director",
      role_name: "Area Director",
      commented_at: annotation.created_at
    }
  }

  /*
   * Prevents duplicate messages from being appended since we're looking
   * at a dynamic view
   */
  noFirstMessage(str) {
    const { annotation } = this.props;
    return !annotation.messages[0] || !annotation.messages[0].id.toString().includes(str)
  }

  /*
   * Used to set the first message on annotations like AddFiles and RemovePages
   */
  setFirstAnnotationMessage(){
    const { annotation } = this.props;
    const { type } = this.state;

    if (this.noFirstMessage(type)) {
      annotation.messages.unshift(this.addFirstMessage(type))
    }
  }

  render() {
    let overlayContent = null;
    const { number, annotation, roleType } = this.props;
    const { step, type } = this.state;

    switch (step) {
      case 'new':
        overlayContent = this.commentAnnotation();
        break;
      default:
        if (type === "comment") {
          overlayContent = this.commentAnnotation();
        } else if (type === 'add_files') {
          this.setFirstAnnotationMessage()
          overlayContent = this.commentAnnotation();
        } else {
          overlayContent = <p>{type} Annotation Here</p>
        }
    }

    return (
      <AnnotationOverlay
        popoverId={number}
        annotation={annotation}
        overlayContent={overlayContent}
        annotationId={number}
        roleType={roleType}
      />
    );
  }
}

StoreProductAnnotationOverlay.propTypes = {
  number: PropTypes.number.isRequired,
  roleType: PropTypes.string.isRequired,
  readOnly: PropTypes.bool.isRequired,
  klass: PropTypes.shape({
    showAnnotationOnLoadId: PropTypes.string,
  }).isRequired,
  annotationTypes: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
  })).isRequired,
  annotation: PropTypes.shape({
    id: PropTypes.string,
    simple_type: PropTypes.string,
  }).isRequired,
};

export default StoreProductAnnotationOverlay;

/* eslint-enable */
